const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export function getPublicChatUsername(username?: string | null) {
  const value = username?.trim();
  if (!value || EMAIL_PATTERN.test(value)) return "Гость";
  return value;
}
